export const defaultServiceTributesState = () => ({
  id: null,
  description: '',
  issPercentage: 0,
  baseIssPercentage: 0,
});

const defaultServiceTributesModuleState = () => ({
  summaryServiceTributes: [],
  paginationServiceTributes: {
    perPage: 15,
    currentPage: 1,
  },
});

const initialState = {
  ...defaultServiceTributesModuleState(),
  warnings: [],
  tributes: {
    ...defaultServiceTributesState(),
  },
};

export default {
  ...initialState,
};
